export const
    THEME = "theme",
    USER = "user",
    MESSAGE = "message"